import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetChatTextMessageTID = (parentTestId)=>getTestIds(parentTestId);
// chat-text is the read-only Q&A reply emitted by the ask lane (option D
// refactor — ANCR-34). It carries no `intro`, no items, no apply/dismiss
// buttons, and no feedback prompt — `text` is the entire reply body rendered
// as a plain chat bubble.
export const ChatTextMessage = (param)=>{
    let { content, messageId } = param;
    const { ChatTextMessageTID } = useMemo(()=>GetChatTextMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": ChatTextMessageTID.Root(),
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: ChatTextMessageTID.Text(),
            children: content.text
        })
    });
};
